import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const EntitiesTranslations = wrapTranslationsSchema({
	name: 'EntitiesTranslations',
	title: 'Entities Translations',
	sanityId: 'entities',
	fields: {
		supplierCountOne: '{count} Supplier',
		supplierCountOther: '{count} Suppliers',
		categoryCountOne: '{count} Category',
		categoryCountOther: '{count} Categories',
		collectionCountOne: '{count} Collection',
		collectionCountOther: '{count} Collections',
		storeCountOne: '{count} Store',
		storeCountOther: '{count} Stores',
		substoreCountOne: '{count} Substore',
		substoreCountOther: '{count} Substores',
		storeOfferingCountOne: '{count} Store offering',
		storeOfferingCountOther: '{count} Store offerings',
		productCountOne: '{count} Product',
		productCountOther: '{count} Products',
		conceptCountOne: '{count} Concept',
		conceptCountOther: '{count} Concepts',
		itemCountOne: '{count} Item',
		itemCountOther: '{count} Items',
	},
});
